import { TripPinsLight } from '@ha/icons';
import React from 'react';
import { makeStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  units,
  Grid,
  Card,
} from '@ha/dsl';
import { useIntl } from 'ha/i18n';

import TravelTimeContentForm from './TravelTimeContentForm';

export const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
  },
  summaryRoot: {
    padding: units.txb(0.75, 0.875, 0.5),
    minHeight: 'auto',

    '&.Mui-expanded ': {
      minHeight: 'auto',
    },
  },
  summaryContent: {
    margin: 0,

    '&.Mui-expanded ': {
      margin: 0,
    },
  },
  expandIcon: {
    margin: 0,
    padding: 0,
  },
  commuteIcon: {
    marginRight: units.rem(0.5),
  },
}));

export const TravelTimeAccordion: React.FC = () => {
  const classes = useStyles();
  const { T } = useIntl();

  return (
    <Card className={classes.container}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          classes={{
            root: classes.summaryRoot,
            content: classes.summaryContent,
            expandIcon: classes.expandIcon,
          }}
        >
          <Grid container wrap="nowrap">
            <Grid item>
              <TripPinsLight className={classes.commuteIcon} />
            </Grid>
            <Grid item>
              <Typography.Paragraph>
                {T('search.map.commute.location.label')}
              </Typography.Paragraph>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <TravelTimeContentForm />
        </AccordionDetails>
      </Accordion>
    </Card>
  );
};

export default TravelTimeAccordion;
